<div class="flex flex-col gap-3" data-testid="pdf-form">
  <input
    #fileInput
    type="file"
    accept="application/pdf"
    multiple
    class="hidden"
    (change)="onPick($event)"
    data-testid="pdf-file-input"
  />

  <div
    class="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-6 text-center transition-colors"
    [class.border-secondary]="dragOver()"
    [class.bg-slate-50]="dragOver()"
    [class.border-slate-300]="!dragOver()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    data-testid="pdf-drop-zone"
  >
    <p class="text-sm text-gray-700">Drag PDFs here</p>
    <p class="text-xs text-gray-500">or</p>
    <button
      type="button"
      class="btn-small-secondary"
      (click)="fileInput.click()"
      data-testid="pdf-pick-button"
    >
      Choose PDF files
    </button>
    <p class="text-xs text-gray-400">Max 100 MB per file</p>
  </div>

  @if (fileErrors().length > 0) {
    <ul class="rounded-md bg-red-50 p-2 text-sm text-red-700" data-testid="pdf-file-errors">
      @for (msg of fileErrors(); track $index) {
        <li>{{ msg }}</li>
      }
    </ul>
  }

  @if (files().length > 0) {
    <ul class="flex flex-col gap-1" data-testid="pdf-selected-files">
      @for (f of files(); track $index; let i = $index) {
        <li
          class="flex items-center justify-between rounded-md bg-slate-50 p-2 text-sm"
          [attr.data-pdf-index]="i"
        >
          <span class="min-w-0 truncate" [attr.title]="f.name">
            {{ f.name }} — {{ formatSize(f.size) }}
          </span>
          <button
            type="button"
            class="ml-2 text-red-600 hover:text-red-700"
            (click)="removeAt(i)"
            aria-label="Remove file"
            data-testid="pdf-remove-file"
          >
            ×
          </button>
        </li>
      }
    </ul>
  }

  @if (submitError(); as msg) {
    <p class="text-sm text-red-700" data-testid="pdf-submit-error">{{ msg }}</p>
  }

  <div class="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
    @if (files().length > 0) {
      <span class="text-sm text-gray-600">{{ files().length }} selected</span>
    } @else {
      <span></span>
    }
    <button
      type="button"
      class="btn-primary w-full sm:w-auto"
      [disabled]="files().length === 0 || submitting()"
      (click)="submit()"
      data-testid="pdf-submit"
    >
      {{ submitting() ? 'Uploading…' : 'Import PDFs' }}
    </button>
  </div>
</div>
